if (!customElements.get('ws-store-header')) {
  customElements.define('ws-store-header', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.toggle = this.querySelector('[data-ws-toggle]');
      this.navigation = this.querySelector('.wss-navigation');
      this.groups = [...this.querySelectorAll('.wss-menu-group, .wss-localization')];
      this.toggle?.addEventListener('click', () => {
        const open = this.toggle.getAttribute('aria-expanded') !== 'true';
        this.toggle.setAttribute('aria-expanded', String(open));
        this.navigation?.classList.toggle('is-open', open);
      }, {signal});
      this.groups.forEach(group => group.addEventListener('toggle', () => {
        if (group.open) this.groups.forEach(other => { if (other !== group) other.open = false; });
      }, {signal}));
      document.addEventListener('click', event => { if (!this.contains(event.target)) this.close(); }, {signal});
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          const opened = this.groups.find(group => group.open);
          if (opened) { opened.open = false; opened.querySelector('summary')?.focus(); }
          else { this.close(); this.toggle?.focus(); }
        }
      }, {signal});
      this.navigation?.addEventListener('click', event => { if (event.target.closest('a')) this.close(); }, {signal});
      this.querySelector('select[name="country_code"]')?.addEventListener('change', event => {
        const language = this.querySelector('select[name="language_code"]');
        const preferences = {NL:['nl','en'],BE:['nl','fr','de','en'],DE:['de','en'],AT:['de','en'],FR:['fr','en'],ES:['es','en'],IT:['it','en'],IE:['en'],GB:['en'],CH:['de','fr','it','en'],LU:['fr','de','en'],LI:['de','en'],MC:['fr','en'],SM:['it','en'],VA:['it','en']};
        const supported = preferences[event.target.value] || ['en'];
        const keepChoice = ['BE', 'CH', 'LU'].includes(event.target.value) && supported.includes(language?.value);
        const preferred = keepChoice ? language.value : supported.find(code => [...(language?.options || [])].some(option => option.value === code));
        if (language && [...language.options].some(option => option.value === preferred)) language.value = preferred;
      }, {signal});
    }
    close() {
      this.groups?.forEach(group => group.open = false);
      this.toggle?.setAttribute('aria-expanded', 'false');
      this.navigation?.classList.remove('is-open');
    }
    disconnectedCallback() { this.controller?.abort(); this.bound = false; }
  });
}
